module.exports = __webpack_public_path__ + "static/media/Epilogue-ExtraLightItalic.282c91ba.ttf";